import type { FilterItem } from '@ctw/shared/components/filter-bar/filter-bar-types';
import { dismissFilter } from '@ctw/shared/content/resource/filters';

export function diagnosticReportFilter(): Array<FilterItem> {
  return [dismissFilter];
}
